import React from "react";
import { ariaDescribedByIds, enumOptionsIndexForValue, enumOptionsValueForIndex, } from "@rjsf/utils";
import clsx from "clsx";
export default function SelectWidget({ schema, id, options, required, disabled, readonly, value, multiple, autofocus, onChange, onBlur, onFocus, placeholder, rawErrors = [], }) {
    const { enumOptions, enumDisabled, emptyValue: optEmptyValue } = options;
    const emptyValue = multiple ? [] : "";
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    function getValue(event, multiple) {
        if (multiple) {
            return ([].slice
                // biome-ignore lint/suspicious/noExplicitAny: <explanation>
                .call(event.target.options)
                // biome-ignore lint/suspicious/noExplicitAny: <explanation>
                .filter((o) => o.selected)
                // biome-ignore lint/suspicious/noExplicitAny: <explanation>
                .map((o) => o.value));
        }
        return event.target.value;
    }
    const selectedIndexes = enumOptionsIndexForValue(value, enumOptions, multiple);
    return (React.createElement("select", { id: id, name: id, value: typeof selectedIndexes === "undefined" ? emptyValue : selectedIndexes, required: required, multiple: multiple, disabled: disabled || readonly, autoFocus: autofocus, className: clsx("bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5", rawErrors.length > 0 && "border-red-500"), onBlur: onBlur &&
            ((event) => {
                const newValue = getValue(event, multiple);
                onBlur(id, enumOptionsValueForIndex(newValue, enumOptions, optEmptyValue));
            }), onFocus: onFocus &&
            ((event) => {
                const newValue = getValue(event, multiple);
                onFocus(id, enumOptionsValueForIndex(newValue, enumOptions, optEmptyValue));
            }), onChange: (event) => {
            const newValue = getValue(event, multiple);
            onChange(enumOptionsValueForIndex(newValue, enumOptions, optEmptyValue));
        }, "aria-describedby": ariaDescribedByIds(id) },
        !multiple && schema.default === undefined && (React.createElement("option", { value: "", className: "bg-muted" }, placeholder)),
        enumOptions.map(({ value, label }, i) => {
            const disabled = Array.isArray(enumDisabled) &&
                enumDisabled.indexOf(value) != -1;
            return (React.createElement("option", { key: i, id: label, value: String(i), disabled: disabled, className: "bg-muted" }, label));
        })));
}
//# sourceMappingURL=SelectWidget.js.map